import { DEFAULT_LANGUAGE, LANGUAGES, type Language } from '@ps/constants';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';

const STORAGE_KEY = 'ps.customer.language';

/** Remembered choice first, then the device language, then English. */
function initialLanguage(): Language {
  // The public pages are also rendered at build time, where there is no window
  // and no device to ask. The prerender sets the language it wants explicitly.
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === LANGUAGES.EN || stored === LANGUAGES.HI) return stored;
  } catch {
    /* storage unavailable — fall through to the device language */
  }
  return navigator.language?.startsWith('hi') ? LANGUAGES.HI : DEFAULT_LANGUAGE;
}

void i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
  },
  lng: initialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(language: Language): void {
  void i18next.changeLanguage(language);
  document.documentElement.lang = language;
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch {
    /* the choice simply will not persist */
  }
}

export const i18n = i18next;
